import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseReportPolicyGuide.module.scss'

import { NCLICK } from '@Root/contants/lcs'
import { handleNclickMix } from '@Helpers/nclick'
import { MY_HOUSE_BOARD_TYPE } from '@Root/contants/myhouse'

const cx = className.bind(style)

type Props = {
  className?: string
  boardType: MY_HOUSE_BOARD_TYPE
}

const MyhouseReportPolicyGuide: React.FC<Props> = ({ className, boardType }: Props) => {
  const naverProfileModifyUrl = `${process.env.REACT_APP_NAVER_PROFILE_MODIFY_URL}`

  return (
    <div className={cx('article', className)}>
      <span className={cx('guide')}>
        ・ 게시글에서는 작성자의 네이버회원 별명과 프로필 사진이 노출됩니다.{' '}
        <a
          href={naverProfileModifyUrl}
          className={cx('link')}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleNclickMix(boardType === MY_HOUSE_BOARD_TYPE.NOTICE ? NCLICK.MY_HOUSE.NOTICE_ENROL.NAVER_PROFILE_URL : NCLICK.MY_HOUSE.REVIEW_ENROL.NAVER_PROFILE_URL)}
        >
          네이버회원 정보 확인/수정하기
        </a>
      </span>
      <span className={cx('guide')}>・ 첨부파일은 JPG, JPEG, PNG, BMP 형식만 가능합니다.</span>
      <span className={cx('guide')}>・ 모니터링 및 신고에 따라 네이버 운영정책에 위반되는 게시물은 삭제될 수 있습니다.</span>
    </div>
  )
}

export default MyhouseReportPolicyGuide
